import { Box, Stack, Text } from '@n26/nxd'
import { Link } from '@components/Link'
import { ERROR_PAGES } from '@constants/errorPages'
import type { AppLanguages, AppLocales } from '@constants/i18n'

export type ErrorBannerProps = {
  locale: AppLocales
  language: AppLanguages
  code: '404' | '5XX'
}

export function ErrorBanner({ locale, language, code }: ErrorBannerProps) {
  const errorType = code === '404' ? 'NotFound' : 'ServerError'

  return (
    <main className='h-[calc(100vh_-_70px)] m-auto max-w-5xl flex items-center -translate-y-[16px] sm:translate-y-0'>
      <Box
        padding='48'
        display='flex'
        flexDirection={{ desktop: 'row', mobile: 'column' }}
        gap={{ desktop: '32', mobile: '0' }}
      >
        <img
          className='m-auto'
          src='https://images.ctfassets.net/iv7ikzngu0lb/4F0mXDitoU7CfwFS6Yt5WV/d9db7429a0bf48fd641b578f7ef35ff0/error-illustration.png'
          alt=''
        />
        <Stack space='16' align={{ mobile: 'center', desktop: 'flex-start' }}>
          <h1 className='font-medium text-34 text-center sm:text-left'>
            {ERROR_PAGES[errorType][language].title}
          </h1>

          <Stack space='4' align={{ mobile: 'center', desktop: 'flex-start' }}>
            <p className='text-center sm:text-left'>
              {ERROR_PAGES[errorType][language].description}
            </p>
            {/* We need to keep the NXD component here to support dark mode */}
            <Text color='neutral-alternate'>
              {ERROR_PAGES[errorType][language].errorCode}
            </Text>
          </Stack>
          <Stack.Separator />
          <Link
            url={`/${locale}`}
            className='underline hover:text-teal text-16'
          >
            {ERROR_PAGES.CTA[language]}
          </Link>
        </Stack>
      </Box>
    </main>
  )
}
